import { MaterialTextInputProps } from '@jfs/ui-new'
import { AdminPortalTextInput } from '../../components/AdminPortalTextInput'

interface MandateAmountTextInputProps extends MaterialTextInputProps {
  allValues?: any
}

export const MandateAmountTextInput = (props: MandateAmountTextInputProps) => {
  const getErrorMeassage =() => {
    const { mandateRuleAmount = 0, oneTimeFee = 0, recurringFee = 0 } = props.allValues
    if (mandateRuleAmount && mandateRuleAmount < Math.max(oneTimeFee, recurringFee)) {
      return '** maximum of oneTimeFee and recurringFee required'
    }
    return props.error
  }
  console.log(props.allValues.recurringFee)
  return <>{props.allValues.recurringFee&&+props.allValues.recurringFee>0 && <AdminPortalTextInput {...props} error={getErrorMeassage()} />}</>
}
